/**
 * @generated SignedSource<<c0ebf82286ddd60f9f8cdba5b0fc9b9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlannerLeftColumn_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonPlannerMenu_user" | "PersonSidePanel_user" | "ProjectPlannerMenu_user" | "ProjectTemplatePlannerMenu_user">;
  readonly " $fragmentType": "PlannerLeftColumn_user";
};
export type PlannerLeftColumn_user$key = {
  readonly " $data"?: PlannerLeftColumn_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlannerLeftColumn_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlannerLeftColumn_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonPlannerMenu_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectPlannerMenu_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectTemplatePlannerMenu_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "ce8577372d7ced3ab79eb4246dbdb2fa";

export default node;
